<template>
  <div class="login-wrap body">
    <div class="login_head header">
      <div class="login_logo pull-left"><img src="../../../static/img/logo.svg" width="120"></div>
      <div class="login_language pull-right">
        <el-dropdown trigger="click" @command="languageCommand">
        <span class="el-dropdown-link" style="font-size: 14px;">
          {{languageStr}}<i class="el-icon-caret-bottom el-icon--right"></i>
        </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="{locale: 'zh'}">{{$t('common.zh')}}</el-dropdown-item>
            <!--<el-dropdown-item :command="{locale: 'tw'}">{{$t('common.tw')}}</el-dropdown-item>-->
            <el-dropdown-item :command="{locale: 'en'}">{{$t('common.en')}}</el-dropdown-item>
            <el-dropdown-item :command="{locale: 'ko'}">{{$t('common.ko')}}</el-dropdown-item>
            <el-dropdown-item :command="{locale: 'ja'}">{{$t('common.ja')}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="main-content">
    <div class="notice_box">
    </div>
    <div class="login_bg">
      <div class="login_main">
        <div class=" login_left_banner">
            <div class="swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide" >
                <a href="https://greater-tokyo-pass.jp/" target="_blank"><div class="swiper_banner " style="background-image:url(/static/img/gtp3.jpg)"></div></a>
              </div>
              <div class="swiper-slide" >
                  <a href="https://www.hozugawakudari.jp/" target="_blank"><div class="swiper_banner " style="background-image:url(/static/img/11.jpg)"></div></a>
              </div>
              <div class="swiper-slide" >
                <a href="http://www.fujisan.ne.jp/" target="_blank"><div class="swiper_banner " style="background-image:url(/static/img/fujisan.jpg)"></div></a>
              </div>
              <div class="swiper-slide" >
                <a href="http://www.tobu.co.jp/foreign/en/pass/all.html" target="_blank"><div class="swiper_banner " style="background-image:url(/static/img/nikkopass.png)"></div></a>
              </div>
              <div class="swiper-slide" >
                <a href="javascript:void(0);"><div class="swiper_banner " style="background-image:url(/static/img/tenku.jpg)"></div></a>
              </div>
              <div class="swiper-slide" >
                <a href="javascript:void(0);"><div class="swiper_banner " style="background-image:url(/static/img/ite.jpg)"></div></a>
              </div>
            </div>
            <!-- Add Pagination -->
            <div class="swiper-pagination"></div>
          </div>
        </div>

      <div class="ms-login">
          <div class="login_logo_new"><a href="#"><img src="./assetts/images/login_logo.png"></a></div>
        <div class="ms-login-title">{{$t('login.userLogin')}}</div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="demo-ruleForm">
          <el-form-item prop="loginName" class="username">
            <el-input v-model="ruleForm.loginName" :placeholder="$t('login.message1')"></el-input>
          </el-form-item>
          <el-form-item prop="password" class="password">
            <el-input type="password" :placeholder="$t('login.message2')" v-model="ruleForm.password" ref="passwordInput"
                      @keyup.enter.native="submitForm('ruleForm')"
                      @keyup.native="(e) => {
                        e.target.value = e.target.value.replace(/[^a-zA-Z0-9]/g, '')
                        ruleForm.password = e.target.value
                      }"
                      ></el-input>
          </el-form-item>
          <div class="forgot_box">
            <div class="pull-left"><el-checkbox v-model="rememberLoginStatus">{{$t('login.rememberLoginStatus')}}</el-checkbox></div>
            <div class="pull-right"><router-link to="backAccount">{{$t('login.forgetPassword')}}</router-link></div>
          </div>
          <div class="login-btn">
            <el-button type="primary" @click="submitForm('ruleForm')">{{$t('login.loginIn')}}</el-button>
          </div>
          <div class="login-btn login-btn-new ">
            <router-link to="selectMerchantType"><el-button>{{$t('login.register')}}</el-button></router-link>
          </div>
        </el-form>
      </div>
      </div>
    </div>
    </div>
    <div class="login_copyright">
      {{$t('login.copyRight')}}<br/>
      <a target="_blank" href="http://beian.miit.gov.cn">{{$t('login.recordInformation')}}</a>&nbsp;
      <a target="_blank" href="https://jph-static.oss-ap-northeast-1.aliyuncs.com/%E7%89%B9%E5%95%86%E6%B3%95%E8%A1%A8%E8%A8%98.pdf">{{$t('login.recordInformation2')}}</a>
    </div>
    </div>
</template>

<script>
  import Swiper from 'swiper'
  import userService from '../../utils/user'
 // import {userList} from '../../mixins/req'
  export default {
    data () {
      return {
        ruleForm: {
          loginName: '',
          password: ''
        },
        rememberLoginStatus: false,
        rules: {
          loginName: [
            {required: true, message: this.$t('login.message1'), trigger: 'blur'}
          ],
          password: [
            {required: true, message: this.$t('login.message2'), trigger: 'blur'},
            { pattern: /^[a-zA-Z0-9]+$/, message: this.$t('login.message3'), trigger: 'blur' }
          ]
        },
        locale: this.$i18n.locale !== null ? this.$i18n.locale : 'en',
        text: this.$t('common.' + (this.$i18n.locale !== null ? this.$i18n.locale : 'en')),
        initImg: '/static/img/login_bg.png',
        showImg: ''
      }
    },
    created () {
      // 读取cookie中的语言
      let langType = this.getCookie1('langType')
      if (langType !== undefined && langType !== null) {
        this.saveLangType(langType)
        this.$i18n.locale = langType
        this.locale = langType
        if (langType === 'zh') {
          this.text = this.$t('common.zh')
        } else if (langType === 'tw') {
          this.text = this.$t('common.tw')
        } else if (langType === 'en') {
          this.text = this.$t('common.en')
        } else if (langType === 'ko') {
          this.text = this.$t('common.ko')
        } else if (langType === 'ja') {
          this.text = this.$t('common.ja')
        }
      } else {
        this.saveLangType('en')
        this.setCookie('langType', 'en', 30)
        this.$i18n.locale = 'en'
        this.text = this.$t('common.en')
      }
      // 初始化图片处理.
      this.getHttpData('/sys/getPageImg', {}, data => {
        if (data) {
          if (data.img === '1') {
            this.isInitImg = true
            this.showImg = 'background-image:url(' + this.initImg + ')'
          } else {
            this.showImg = 'background-image:url(' + data.img + ')'
          }
        }
      })
    },
    mounted () {
      /* eslint-disable no-new */
      new Swiper('.swiper-container', {
        autoplay: {
          disableOnInteraction: false
        },
        loop: true,
        pagination: '.swiper-pagination',
        slidesPerView: 1,
        paginationClickable: true
      })
    },
    computed: {
      languageStr () {
        return this.text
      }
    },
    methods: {
      submitForm (formName) {
        let _this = this
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.saveLangType(this.$i18n.locale)
            this.postHttpData('/sys/user/login', require('qs').stringify(this.ruleForm), (data, s, errorMsg) => {
              if (data) {
                userService.save(data)
                this.base_go('/sysHome', true)
                var Days = 30
                var exp = new Date()
                if (_this.rememberLoginStatus) {
                  // 有效期30天
                  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000)
                  document.cookie = 'sys.user.accessToken=' + data.accessToken + ';expires=' + exp.toGMTString() + ';path=/'
                } else {
                  exp.setTime(exp.getTime() + 1 * 1 * 1 * 1 * 1)
                  document.cookie = 'sys.user.accessToken=;expires=' + exp.toGMTString() + ';path=/'
                }
                // 登陆成功，获取对应的页面级控制
                this.getHttpData('/sys/href', '', data => {
                  if (data) {
                    let hrefList = []
                    data.hrefList.forEach(item => {
                      hrefList.push(item.href)
                    })
                    sessionStorage.setItem('href', hrefList)
                  }
                })
              } else {
                if (errorMsg) {
                  this.$message.error(_this.$t('errorMsg.user.' + errorMsg))
                  return
                }
              }
            })
          }
        })
      },
      languageCommand (command) {
        this.locale = command.locale
      }
    },
    watch: {
      locale (val) {
        this.$i18n.locale = val
        this.saveLangType(val)
        this.setCookie('langType', val, 30)
        if (val === 'zh') {
          this.text = this.$t('common.zh')
        } else if (val === 'tw') {
          this.text = this.$t('common.tw')
        } else if (val === 'en') {
          this.text = this.$t('common.en')
        } else if (val === 'ko') {
          this.text = this.$t('common.ko')
        } else if (val === 'ja') {
          this.text = this.$t('common.ja')
        }
      }
    }
  }
</script>
<style scoped>
  @import 'assetts/css/swiper.min.css';
</style>
<style>
  .forgot_box .el-checkbox__label { font-size: 12px; padding-left: 5px; color: #999;}
  .username .el-input input { padding-left:40px; background-image: url("../../../static/img/user.png"); background-repeat: no-repeat; background-position: 10px 7px; }
  .password .el-input input { padding-left:40px; background-image: url("../../../static/img/password.png"); background-repeat: no-repeat; background-position: 10px 7px; }
</style>
  <style scoped>
  .login-wrap { position:absolute; left:0px; right:0px; top:0px; bottom:0px; overflow:auto; background: #fff;}
  .login_head { width:1060px; height: 60px; margin:0px auto; padding-top:15px;}
  .login_language { padding-top: 10px;}
  .notice_box { width: 100%; margin:0px auto; color:#FFF;}
  .notice_box .notice_content { width: 1060px; margin: 0px auto; padding-top: 5px; padding-bottom: 5px;}
  .notice_box .notice_content a { color:#078CCE; line-height: 14px;}
  .notice_box .notice_content a:hover { text-decoration: underline;}
  .notice_box .notice_content span { display: inline-block; height: 100%; vertical-align: middle; padding-left:10px;}
  .notice_box .notice_content img { vertical-align: middle;}
  .login_bg { width: 100%; height: 500px; background-position: center; background-repeat: no-repeat; background-size:cover;}
  .login_main { width:1060px; height:500px; margin: 0px auto;}
  .login_ad { margin-top: 40px;}
  .ms-login { float:right; width: 300px; height: 400px; padding: 30px; padding-top: 0px; border-radius: 3px; margin-top: 50px; background: #fff; }
  .login_copyright { text-align: center; line-height: 22px; padding-top:10px; padding-bottom:10px;}
  .login-btn { text-align: center; margin-bottom: 15px;}
  .login-btn button { width: 100%; height: 36px;}
  .ms-login-title { width: 100%; font-size:18px; text-align: center; line-height:50px; border-bottom:1px solid #eee; margin-bottom: 20px;}
  .forgot_box { padding-bottom: 15px; font-size:12px; float:left; width: 100%;}
</style>

<style>
.body{
    display: flex;
    flex-direction: column;
    height: 100%;
}
.header{
	flex: 0 0 auto;
}
.main-content{
    flex: 1 0 auto;
    padding-top:20px;
    background-color: #009688;
}
.footer{
	flex: 0 0 auto;
}
.log-left{ float: left; width:50%;}
.log-left img{ width: 100%; height:auto;}
.login_logo_new {
    width: 120px;
    height: 120px;
    border: 5px solid #1ab5a7;
    border-radius: 100px;
    background: #fff;
    text-align: center;
    line-height: 110px;
    margin:-50px auto 0px auto;
}
.login_logo_new img {
    width: 60px;
    height: 60px;
    display: inline-block;
    vertical-align: middle;
}
.el-checkbox__input.is-checked .el-checkbox__inner{
    background-color: #009688;
    border-color: #009688;
}
.login-btn-new a .el-button:hover{
    border-color: #009688;
    color:#009688;
}

.login_left_banner{
  width: calc(100% - 440px);
  width: -webkit-calc(100% - 440px);
  width: -moz-calc(100% - 440px);
  float:left;
  margin-top:50px;
  height:430px;
}
.swiper-container {
  width: 100%;
  height: 100%;
  margin-left: auto;
  margin-right: auto;
  border-radius: 6px;
  overflow:hidden;
}
.swiper_banner {
  width: 100%;
  height: 430px;
  background-position: center !important;
  background-repeat: no-repeat !important;
  background-size: contain !important;
}

</style>




// WEBPACK FOOTER //
// loginNew.vue?325ddfb6